module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/mediame_logo-6ab7cc02a28756f61569ea79e42b36f3.svg";